import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';
import DeleteModal from '@/components/atoms/DeleteModal';
import { computeText } from '@/locales/utils';
import { DangerSection, DangerTitle, DangerButton, DeleteContent, DateText, ErrorText } from '../RestaurantInfo.style';

type DeleteRestaurantSectionProps = {
    createdAt?: string;
    onDelete: () => Promise<void>;
    isDeleting: boolean;
    brandId: string;
};

export const DeleteRestaurantSection: React.FunctionComponent<DeleteRestaurantSectionProps> = ({
    createdAt,
    onDelete,
    isDeleting,
    brandId,
}) => {
    const intl = useIntl();
    const history = useHistory();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error, setError] = useState<string>();

    const handleSubmit = async () => {
        try {
            await onDelete();
            setIsModalOpen(false);
            history.push(`/brands/${brandId}/restaurants`);
        } catch {
            setError(computeText(intl, 'restaurantInfo.delete.error'));
        }
    };

    const formattedDate = createdAt
        ? new Date(createdAt).toLocaleDateString(intl.locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
          })
        : undefined;

    return (
        <DangerSection>
            <DangerTitle>{computeText(intl, 'restaurantInfo.delete.title')}</DangerTitle>
            <DeleteContent>
                {formattedDate && (
                    <DateText>
                        {computeText(intl, 'restaurantInfo.delete.description')} {formattedDate}
                    </DateText>
                )}
                <DangerButton onClick={() => setIsModalOpen(true)}>
                    {computeText(intl, 'restaurantInfo.delete.button')}
                </DangerButton>
                {error && <ErrorText>{error}</ErrorText>}
            </DeleteContent>
            <DeleteModal
                title="restaurantInfo.delete.confirmTitle"
                description="restaurantInfo.delete.confirmDescription"
                isOpen={isModalOpen}
                onHide={() => setIsModalOpen(false)}
                onSubmit={handleSubmit}
                isLoading={isDeleting}
            />
        </DangerSection>
    );
};
